import { ServiceStore } from "@intrasync/stores";
import { RouteType } from "types/RouteType";

const SubmittalPackageWizardRoute: RouteType = {
  name: "SubmittalPackageWizard",
  path: "/workflows/submittal-package",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Engineering Submittal Package Builder",
      component: () => import("./SubmittalPackageWizardHeader"),
      enableRefreshButton: false,
      enableBackButton: true,
    },
    body: {
      component: () => import("./SubmittalPackageWizard"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    try {
      // Load necessary data for the wizard
      const jobStore = rootStore.jobStore as ServiceStore;
      const contactsStore = rootStore.contactsStore as ServiceStore;
      const userStore = rootStore.userStore as ServiceStore;
      const productsStore = rootStore.productsStore as ServiceStore;
      const submittalsStore = rootStore.submittalsStore as ServiceStore;

      await Promise.all([
        jobStore?.find(),
        contactsStore?.find(),
        userStore?.find(),
        productsStore?.find(),
        submittalsStore?.find(),
      ]);

      return true;
    } catch (error) {
      console.error("Failed to load data for submittal package builder:", error);
      return false;
    }
  },
  onExit: ({ rootStore }) => {
    // Reset the wizard state when leaving
    const store = (rootStore as any).submittalPackageWizardStore;
    store?.reset();
  },
};

export default SubmittalPackageWizardRoute;